const namespace = 'resetPassword';

export const VALIDATE_RESET_PASSWORD_TOKEN = `${namespace}/VALIDATE_RESET_PASSWORD_TOKEN`;
export const SUBMIT_RESET_PASSWORD = `${namespace}/SUBMIT_RESET_PASSWORD`;
export const SUBMIT_NEW_PASSWORD = `${namespace}/SUBMIT_NEW_PASSWORD`;
export const SET_RESENT_PASSWORD_STATUS = `${namespace}/SET_RESENT_PASSWORD_STATUS`;
export const RESENT_PASSWORD_IN_ACCOUNT = `${namespace}/RESENT_PASSWORD_IN_ACCOUNT`;
